export enum GrowthBookTestType {}

export enum TestVariants {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E',
  F = 'F',
  G = 'G',
  H = 'H'
}

export type ExtractEnumKeys<T extends string> = T extends `${infer Prefix}-${string}`
  ? PrefixToTestVariant<Uppercase<Prefix>>
  : T extends `${infer Prefix}_${string}`
    ? PrefixToTestVariant<Uppercase<Prefix>>
    : never;

// Convert extracted letters into corresponding TestVariants keys
type PrefixToTestVariant<T extends string, Acc = never> = T extends `${infer First}${infer Rest}`
  ? First extends keyof typeof TestVariants
    ? PrefixToTestVariant<Rest, Acc | (typeof TestVariants)[First]> // Map to TestVariants keys
    : PrefixToTestVariant<Rest, Acc>
  : Acc;

// Generic resolver
export type ResultTestVariants<T extends string> = ExtractEnumKeys<T>;
